export default __webpack_public_path__ + "a3907a7077d4c3e4537ad08596f41957.png";